import { AfterViewInit, Component, ElementRef, Input, NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import {RouterModule} from '@angular/router';


@Component({
  selector: 'lcms-simple-card1',
  templateUrl: './simple-card1.component.html',
  styleUrls: ['./simple-card1.component.scss'],
})
export class SimpleCard1Component{
  @Input() catalogue: any;

  @Input() cssClass: string;
  @Input() chartSize: number;
  @Input() chartLine: number;
  @Input() chartRotate?: number;
  constructor(public elRef: ElementRef) {}

  ngOnInit(): void {
    setTimeout(() => {
      this.initChart(this.chartSize, this.chartLine, this.chartRotate);
    }, 10);
  }

  // ngAfterViewInit(){
  //   this.initChart(this.chartSize, this.chartLine, this.chartRotate);
  // }

  initChart  (
    chartSize: number = 70,
    chartLine: number = 11,
    chartRotate: number = 145
  ) {

    
    const el = this.elRef.nativeElement.querySelector('.chartElement')
    //  document.getElementById('kt_card_widget_' + chart_id + '_chart');

    console.log('id',el);
    
    if (!el) {
      return;
    }

    const options = {
      size: chartSize,
      lineWidth: chartLine,
      rotate: chartRotate,
    };

    const canvas = document.createElement('canvas');
    const span = document.createElement('span');

    // eslint-disable-next-line @typescript-eslint/ban-ts-comment
    // @ts-ignore
    if (typeof G_vmlCanvasManager !== 'undefined') {
      // eslint-disable-next-line @typescript-eslint/ban-ts-comment
      // @ts-ignore
      G_vmlCanvasManager.initElement(canvas);
    }

    const ctx = canvas.getContext('2d');
    canvas.width = canvas.height = options.size;

    el.appendChild(span);
    el.appendChild(canvas);

    // eslint-disable-next-line @typescript-eslint/ban-ts-comment
    // @ts-ignore
    ctx.translate(options.size / 2, options.size / 2); // change center
    // eslint-disable-next-line @typescript-eslint/ban-ts-comment
    // @ts-ignore
    ctx.rotate((-1 / 2 + options.rotate / 180) * Math.PI); // rotate -90 deg

    //imd = ctx.getImageData(0, 0, 240, 240);
    const radius = (options.size - options.lineWidth) / 2;

    const drawCircle = function (
      color: string,
      lineWidth: number,
      percent: number
    ) {
      percent = Math.min(Math.max(0, percent || 1), 1);
      if (!ctx) {
        return;
      }

      ctx.beginPath();
      ctx.arc(0, 0, radius, 0, Math.PI * 2 * percent, false);
      ctx.strokeStyle = color;
      ctx.lineCap = 'round'; // butt, round or square
      ctx.lineWidth = lineWidth;
      ctx.stroke();
    };

    // Init
    drawCircle('#E4E6EF', options.lineWidth, 100 / 100);
    drawCircle('#6a1fff', options.lineWidth, 100 / 150);
    drawCircle('#00FC8E', options.lineWidth, 100 / 250);
  };
}
@NgModule({
  imports: [CommonModule,RouterModule],
  declarations: [SimpleCard1Component],
  exports: [SimpleCard1Component],
})
export class SimpleCard1ComponentModule {}
